export default "__VITE_ASSET__BrjTmM2$__"